var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgScroll6 = function SvgScroll6(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "scroll_6_svg__scroll",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 203 265",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_6_svg__radial-gradient",
    cx: -30.3221,
    cy: -2.9745,
    r: 453.1591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bf53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3524,
    stopColor: "#4c8782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7922,
    stopColor: "#6946b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#752dce"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_6_svg__radial-gradient-2",
    cx: -17.5824,
    cy: -22.9341,
    r: 415.1728,
    xlinkHref: "#scroll_6_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_6_svg__radial-gradient-3",
    cx: -46.1359,
    cy: -77.1545,
    r: 524.3082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bf53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2446,
    stopColor: "#449f74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7577,
    stopColor: "#6761b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7549ce"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_6_svg__radial-gradient-4",
    cx: 51.8002,
    cy: -42.2259,
    r: 344.4723,
    xlinkHref: "#scroll_6_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_6_svg__radial-gradient-5",
    cx: -0.033,
    cy: -15.0156,
    r: 390.4228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4cbf53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3524,
    stopColor: "#5c8782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7922,
    stopColor: "#6e46b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#752dce"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_6_svg__radial-gradient-6",
    cx: -58.643,
    cy: -68.7222,
    r: 526.196,
    xlinkHref: "#scroll_6_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_6_svg__radial-gradient-7",
    cx: -124.5475,
    cy: 69.3291,
    r: 225.4248,
    gradientTransform: "translate(3.6986 4.6322) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6e473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3fbfc4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_6_svg__radial-gradient-8",
    cx: 145.4365,
    cy: 12.0769,
    r: 186.4762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fea95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8087fe"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_6_svg__radial-gradient-9",
    cx: 53.4144,
    cy: 68.0891,
    r: 137.2539,
    gradientTransform: "translate(3.6986 4.6322) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#72c2bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2444,
    stopColor: "#71c0c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    stopColor: "#6fbacd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7415,
    stopColor: "#6bafe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9906,
    stopColor: "#66a1fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66a0ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_6_svg__radial-gradient-10",
    cx: -10.8012,
    cy: 148.4015,
    r: 155.4494,
    gradientTransform: "translate(3.6986 4.6322) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1933,
    stopColor: "#31c4be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3894,
    stopColor: "#3dbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5866,
    stopColor: "#52b3c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7848,
    stopColor: "#6ea5ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9819,
    stopColor: "#9292d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9690d2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_6_svg__radial-gradient-11",
    cx: 167.9153,
    cy: 168.006,
    r: 170.0956,
    gradientTransform: "translate(3.6986 4.6322) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97aaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#61c7c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48d5b9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_6_svg__radial-gradient-12",
    cx: 34.1102,
    cy: 147.5639,
    r: 73.7703,
    gradientTransform: "translate(3.6986 4.6322) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2565,
    stopColor: "#51c4c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5165,
    stopColor: "#5dbdc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7771,
    stopColor: "#71b1d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89a4e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "scroll_6_svg__linear-gradient",
    x1: 51.711,
    y1: 185.0888,
    x2: 143.9376,
    y2: 171.5796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2ab8c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#897ac2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_6_svg__radial-gradient-13",
    cx: 16.6117,
    cy: 201.2832,
    r: 119.5325,
    gradientTransform: "translate(3.6986 4.6322) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79c6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    stopColor: "#79c2bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3702,
    stopColor: "#78b6bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#76a1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7463,
    stopColor: "#7485c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9337,
    stopColor: "#7161c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7052c9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "scroll_6_svg__left-bottom"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scroll_6_svg__inner"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197,55c-2.9769,12.36-7.2573,29.1909-13,49-5.2314,18.0452-14.4025,49.462-30,89-10.3051,26.1223-21.15,50.1381-32,72L96.013,225.6728q-10.4184-42.6786-20.8369-85.3571Q38.088,70.658,1,1l99,44Z",
    style: {
      fill: "url(#scroll_6_svg__radial-gradient)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "scroll_6_svg__shapes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,45,82,64,0,0Z",
    style: {
      fill: "url(#scroll_6_svg__radial-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,45,82,63l84,11,37-23Z",
    style: {
      fill: "url(#scroll_6_svg__radial-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,74l37-23-20,57-30,15Z",
    style: {
      fill: "url(#scroll_6_svg__radial-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,196l34-5q10-41.5,20-83l-30,15Z",
    style: {
      fill: "url(#scroll_6_svg__radial-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,196l34-5-41,74Q125.5,230.5,129,196Z",
    style: {
      fill: "url(#scroll_6_svg__radial-gradient-6)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "scroll_6_svg___Layer_",
    "data-name": "<Layer>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82,63l-6,76-1.307,1.832Q37.3465,70.416,0,0Z",
    style: {
      fill: "url(#scroll_6_svg__radial-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,63l5,7,61,51,5,1.4615L166,74Z",
    style: {
      fill: "url(#scroll_6_svg__radial-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,63q-.5,3.5-1,7l15,84c15.6845-7.5821,31.7435-16.1958,48-26q4.5642-2.7526,9-5.5385Z",
    style: {
      fill: "url(#scroll_6_svg__radial-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,122.4615,146,139l-44,80-6,7q-.5-7-1-14V158l2-5Z",
    style: {
      fill: "url(#scroll_6_svg__radial-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.693,140.832Q76.3465,142.916,78,145l15,9,4-1L82,63h0Z",
    style: {
      fill: "url(#scroll_6_svg__radial-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,153q-.5,36.5-1,73-10.6536-42.5839-21.307-85.168Z",
    style: {
      fill: "url(#scroll_6_svg__radial-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,123,96,226l5-2,24-23,4-5Q140.5,159.5,152,123Z",
    style: {
      fill: "url(#scroll_6_svg__linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,196,96,226l26,39Q125.5,230.5,129,196Z",
    style: {
      fill: "url(#scroll_6_svg__radial-gradient-13)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "scroll_6_svg__highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90,109q4,21.5,8,43l32-17L98,154q-.5,13-1,26-.5-13.5-1-27Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,226l11,16-9-16,20-20Z",
    style: {
      fill: "#f2f2f2"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgScroll6);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scroll_6.82466462caa822e5df2c53887ee84161.svg";